<div class="doc-page">
    <article class="doc-shell">
        <header class="doc-header">
            <p class="doc-eyebrow">Informativa</p>
            <h1 class="doc-title" itemprop="headline">
                Cookie e come voi ne beneficiate
            </h1>
            <p class="doc-lead">
                Come usiamo i cookie sul nostro sito e come puoi gestirli dal tuo
                browser.
            </p>
        </header>

        <section class="doc-card">
            <p>
                Il nostro sito utilizza i cookie, come quasi tutti i siti web fanno,
                per aiutarvi a fornire la migliore esperienza possibile.
            </p>
            <p>
                I cookie sono piccoli file di testo che vengono depositati sul
                Vostro computer o telefono cellulare durante la navigazione di siti
                web.
            </p>

            <div class="doc-split">
                <div class="doc-panel doc-panel--yes">
                    <h2 class="doc-panel__title">I nostri cookie ci aiutano:</h2>
                    <ul class="doc-bullets">
                        <li>A far lavorare il sito web come ci si aspetterebbe</li>
                        <li>A migliorare la velocità e la sicurezza del sito</li>
                        <li>
                            Ti permettono di condividere le pagine con le reti
                            sociali come Facebook
                        </li>
                        <li>A migliorare continuamente il nostro sito web per voi</li>
                    </ul>
                </div>

                <div class="doc-panel doc-panel--no">
                    <h2 class="doc-panel__title">Non viene fatto uso di cookies per:</h2>
                    <ul class="doc-bullets">
                        <li>
                            Raccogliere informazioni di identificazione personale
                            (senza il tuo esplicito consenso)
                        </li>
                        <li>
                            Raccogliere informazioni sensibili (senza il tuo
                            esplicito consenso)
                        </li>
                        <li>Passare dei dati alle reti pubblicitarie</li>
                        <li>Passare i dati di identificazione personale a terzi</li>
                        <li>Commissioni di vendita</li>
                    </ul>
                </div>
            </div>

            <p>
                Se le impostazioni del software che si sta utilizzando per la
                visione del sito (il browser) sono regolati per accettare i cookie,
                accettiamo questa impostazione. Se si desidera rimuovere o non usare
                i cookies dal nostro sito si può, come descritto più avanti, però
                così facendo il nostro sito potrebbe non funzionare come ci si
                aspetterebbe.
            </p>
        </section>

        <section class="doc-card">
            <h2 class="doc-section__title">Social website cookie</h2>
            <p>
                Per condividere facilmente il nostro contenuto su siti come Facebook
                abbiamo incluso pulsanti di condvisione. Le implicazioni di privacy
                su questi siti variano da social network a social network e saranno
                dipende dalle impostazioni di privacy che avete scelto su queste
                reti.
            </p>

            <h2 class="doc-section__title">Statistiche dei visitatori</h2>
            <p>
                I cookie vengono utilizzati per compilare statistiche dei
                visitatori, come il numero di persone hanno visitato il nostro sito
                web, che tipo di tecnologia che stanno utilizzando (per esempio Mac
                o Windows, che aiuta a identificare quando il nostro sito non
                funziona come dovrebbe per particolari tecnologie) , quanto tempo
                passano sul sito, quale pagina leggono ecc Questo ci aiuta a
                migliorare continuamente il nostro sito web. Questi programmi ci
                dicono anche se come la gente ha raggiunto questo sito (ad esempio,
                da un motore di ricerca), e se sono stati qui prima e ci aiuta a
                sviluppare i nostri servizi per voi.
            </p>

            <h2 class="doc-section__title">Disabilitare i cookie</h2>
            <p>
                Di solito è possibile disattivare i cookies modificando le
                impostazioni del browser per impedire di accettare i cookie. In
                questo modo però sarà probabilmente limitata la funzionalità del
                nostro e di una gran parte dei siti web di tutto il mondo poichè i
                cookie sono una parte standard della maggior parte dei siti web
                moderni. Invece di disabilitare i cookie nel browser, è conisgliato
                installare un software anti-spyware che raggiunge lo stesso obiettivo
                eliminando automaticamente i cookie considerati invasivi.
            </p>
        </section>

        <section class="doc-card">
            <h2 class="doc-section__title">Internet Explorer 9.0+</h2>
            <ol class="doc-steps">
                <li>Selezionare Strumenti sulla barra dei menu</li>
                <li>Fare clic su Opzioni Internet</li>
                <li>Fare clic sulla scheda Privacy in alto</li>
                <li>Spostare il cursore sul pulsante “Blocca tutti i cookie”</li>
            </ol>
            <p class="doc-steps__label">Rimuovere i cookie esistenti</p>
            <ol class="doc-steps">
                <li>Selezionare Strumenti sulla barra dei menu</li>
                <li>Fare clic su Opzioni Internet</li>
                <li>
                    Fare clic sulla scheda Generale, che si trova sotto la voce
                    “Cronologia esplorazioni” e fare clic su “Elimina”
                </li>
            </ol>

            <h2 class="doc-section__title">Firefox 2.0+, 3.0+, 4.0+</h2>
            <ol class="doc-steps">
                <li>Selezionare Strumenti sulla barra dei menu</li>
                <li>Fare clic su Opzioni</li>
                <li>Fare clic sulla scheda Privacy</li>
                <li>
                    Annullare la selezione della casella "Accetta i cookie dai siti”
                </li>
            </ol>
            <p class="doc-steps__label">Rimuovere i cookie esistenti</p>
            <ol class="doc-steps">
                <li>Selezionare Strumenti sulla barra dei menu</li>
                <li>Fare clic su Opzioni</li>
                <li>Fare clic sulla scheda Privacy</li>
                <li>Fare clic su “Cancella adesso”</li>
                <li>Selezionare “Cookie”</li>
                <li>Fare clic su “Elimina i dati personali adesso”</li>
            </ol>

            <h2 class="doc-section__title">Google Chrome</h2>
            <ol class="doc-steps">
                <li>
                    Fare clic sull’icona della chiave inglese in alto a destra del
                    browser
                </li>
                <li>Fare clic su “Opzioni”</li>
                <li>Fare clic su “Roba da smanettoni”</li>
                <li>
                    Fare clic sul pulsante “Impostazioni contenuti” nella sezione
                    Privacy
                </li>
                <li>
                    Accertarsi che l’opzione “Consenti il salvataggio dei dati in
                    locale” sia selezionata
                </li>
                <li>Selezionare “Impedisci ai siti di impostare dati”</li>
            </ol>
            <p class="doc-steps__label">Rimuovere i cookie esistenti</p>
            <ol class="doc-steps">
                <li>
                    Fare clic sull’icona della chiave inglese in alto a destra del
                    browser
                </li>
                <li>Fare clic su “Opzioni”</li>
                <li>Fare clic su “Roba da smanettoni”</li>
                <li>
                    Fare clic sul pulsante “Impostazioni contenuti” nella sezione
                    Privacy
                </li>
                <li>Fare clic sul pulsante “Cancella dati di navigazione”</li>
            </ol>

            <h2 class="doc-section__title">Safari</h2>
            <ol class="doc-steps">
                <li>
                    Andare al menu Safari (icona in alto a destra del browser) e
                    selezionare Preferenze
                </li>
                <li>
                    Nella finestra a comparsa che si apre, selezionare l’icona
                    Sicurezza (a forma di lucchetto)
                </li>
                <li>
                    Sotto la voce "Accetta cookie", selezionare il pulsante "Mai"
                </li>
            </ol>
        </section>
    </article>
</div>
